import { Injectable } from '@angular/core';
import { RepositoryService, UnitOfWorkService } from '@mri/breeze-entity';
import { MetadataStore } from 'breeze-client';
import { UserReportFilter } from '../models';
import { userReportFilterQueries } from './queries';

@Injectable({ providedIn: 'root' })
export class UserReportFilterRepositoryService extends RepositoryService<UserReportFilter> {
  constructor(uow: UnitOfWorkService, metadataStore: MetadataStore) {
    super(uow, metadataStore, userReportFilterQueries.selectAll);
  }
}
